(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__bbBuyButtonsInit) return;
  window.__bbBuyButtonsInit = true;

  function qs(el, sel) { return el.querySelector(sel); }

  function init(root) {
    if (!root || root.dataset.bbInit) return;
    root.dataset.bbInit = 'true';

    var cfg = {};
    var cfgEl = qs(root, '[data-bb-config]');
    if (cfgEl) {
      try { cfg = JSON.parse(cfgEl.textContent); } catch (e) {}
    }

    var form = qs(root, '[data-bb-form]');
    var idInput = qs(root, '[data-bb-variant-id]');
    var addBtn = qs(root, '[data-bb-add]');
    var addText = qs(root, '[data-bb-add-text]');
    var buyBtn = qs(root, '[data-bb-buy]');
    var statusEl = qs(root, '[data-bb-status]');
    if (!form || !addBtn) return;

    var addedTimer = null;
    var lastSubmitter = null;

    form.addEventListener('click', function (e) {
      var b = e.target.closest('button[type="submit"]');
      if (b) lastSubmitter = b;
    }, true);

    var section = root.closest('.shopify-section') || document;

    function sizePending() {
      return Boolean(window.ZehnSizeGate && window.ZehnSizeGate.isPending(section));
    }

    form.addEventListener('submit', function (e) {
      // Review F2: no size is preselected, so ask for one before buying.
      if (sizePending()) {
        e.preventDefault();
        showStatus(cfg.chooseSizeText);
        window.ZehnSizeGate.prompt(section);
        return;
      }
      var who = e.submitter || lastSubmitter;
      if (who && who === buyBtn) return; // real navigation to /checkout, no JS needed
      e.preventDefault();
      addToCart();
    });

    function showStatus(msg) {
      if (!statusEl) return;
      statusEl.textContent = msg;
      statusEl.hidden = false;
    }
    function hideStatus() {
      if (statusEl) statusEl.hidden = true;
    }

    function resetAdd() {
      if (addedTimer) { clearTimeout(addedTimer); addedTimer = null; }
      addBtn.classList.remove('is-added', 'is-loading');
      if (addText) addText.textContent = cfg.addToCartText;
    }

    function markAdded() {
      addBtn.classList.remove('is-loading');
      addBtn.classList.add('is-added');
      if (addText) addText.textContent = cfg.addedText;
      if (addedTimer) clearTimeout(addedTimer);
      addedTimer = setTimeout(resetAdd, cfg.addedMs);
    }

    function refreshCart() {
      var d = window.ZehnCartDrawer;
      if (d && typeof d.refresh === 'function') return Promise.resolve(d.refresh());
      document.dispatchEvent(new CustomEvent('zehn:cart:refresh', { bubbles: true }));
      return Promise.resolve();
    }

    function openDrawer() {
      var d = window.ZehnCartDrawer;
      if (d && typeof d.open === 'function') d.open();
      else document.dispatchEvent(new CustomEvent('zehn:cart:open', { bubbles: true }));
    }

    function addToCart() {
      var id = idInput ? idInput.value : '';
      if (!id || addBtn.classList.contains('is-loading')) return;

      hideStatus();
      addBtn.classList.add('is-loading');
      addBtn.disabled = true;
      if (buyBtn) buyBtn.disabled = true;

      fetch(cfg.addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      })
        .then(function (res) {
          return res.json().then(function (data) { return { ok: res.ok, data: data }; });
        })
        .then(function (r) {
          if (!r.ok) throw new Error((r.data && (r.data.description || r.data.message)) || '');
          addBtn.disabled = false;
          if (buyBtn) buyBtn.disabled = false;
          markAdded();
          return refreshCart().then(function () {
            if (cfg.afterAdd === 'drawer') openDrawer();
          });
        })
        .catch(function (err) {
          addBtn.classList.remove('is-loading');
          addBtn.disabled = false;
          if (buyBtn) buyBtn.disabled = false;
          showStatus((err && err.message) || cfg.errorText);
        });
    }

    /* Button state for a variant: enabled + label, or sold out / unavailable. */
    function setAvailability(available, label) {
      resetAdd();
      addBtn.disabled = !available;
      if (buyBtn) buyBtn.disabled = !available;
      cfg.addToCartText = label;
      if (addText) addText.textContent = label;
    }

    function syncVariant(variant) {
      if (sizePending()) {
        // No size picked yet: the variant the server resolved is only a
        // placeholder, so don't show its stock (e.g. "Ausverkauft" for 28W).
        setAvailability(cfg.productAvailable, cfg.availableText);
        return;
      }
      hideStatus();
      if (!variant || !variant.id) {
        setAvailability(false, cfg.unavailableText);
        return;
      }
      if (idInput) idInput.value = variant.id;
      setAvailability(Boolean(variant.available), variant.available ? cfg.availableText : cfg.soldOutText);
    }

    /*
      Variant sync. The variant picker announces changes with Shopify's
      ProductSelectEvent (the price and SKU blocks listen to it the same way);
      its promise resolves with detail.resource = the selected variant JSON
      once the picker has re-rendered. Without this, the hidden id input kept
      the variant the page loaded with, so the wrong size/colour was added.
    */
    import('@shopify/events').then(function (events) {
      section.addEventListener(events.StandardEvents.productSelect, function (event) {
        if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog, [data-qa]')) return;
        if (!event.promise) return;
        event.promise.then(function (result) {
          var detail = (result && result.detail) || {};
          // Another product's picker in the same section (not a combined-listing switch).
          if (detail.productId && String(detail.productId) !== cfg.productId && !detail.newProduct) return;
          syncVariant(detail.resource || null);
        }).catch(function () { /* aborted by a newer selection */ });
      });
    }).catch(function () { /* events module unavailable; keep the loaded variant */ });

    // The size gate script may load after this one; check once the page is parsed.
    function initialSync() { if (sizePending()) syncVariant(null); }
    initialSync();
    document.addEventListener('DOMContentLoaded', initialSync);
  }

  function scan() {
    document.querySelectorAll('.bb-root').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('shopify:section:load', scan);
  scan();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["facets"] && !Shopify.designMode) return;
  try {
    class FacetsFilterBar extends HTMLElement {
  constructor() {
    super();
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  connectedCallback() {
    this.form = this.querySelector('[data-facets-form]');
    this.addEventListener('click', this.onClick);
    document.addEventListener('click', this.onDocumentClick);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocumentClick);
  }

  onDocumentClick(event) {
    if (!this.isConnected) return;
    if (!this.contains(event.target)) this.closeAllPanels();
  }

  closeAllPanels() {
    this.querySelectorAll('[data-facet-panel], [data-sort-panel]').forEach((panel) => {
      panel.classList.add('hidden');
    });
    this.querySelectorAll('[data-facet-trigger], [data-sort-trigger]').forEach((trigger) => {
      trigger.setAttribute('aria-expanded', 'false');
      const chevron = trigger.querySelector('svg');
      if (chevron) chevron.classList.remove('rotate-180');
    });
  }

  onClick(event) {
    const trigger = event.target.closest('[data-facet-trigger], [data-sort-trigger]');
    if (trigger) {
      event.preventDefault();
      const panel = trigger.nextElementSibling;
      const wasOpen = trigger.getAttribute('aria-expanded') === 'true';
      this.closeAllPanels();
      if (!wasOpen && panel) {
        panel.classList.remove('hidden');
        trigger.setAttribute('aria-expanded', 'true');
        const chevron = trigger.querySelector('svg');
        if (chevron) chevron.classList.add('rotate-180');
      }
      return;
    }

    const option = event.target.closest('[data-facet-option]');
    if (option) {
      event.preventDefault();
      if (option.disabled) return;
      const isActive = option.getAttribute('aria-pressed') === 'true';
      const url = isActive ? option.dataset.urlRemove : option.dataset.urlAdd;
      this.closeAllPanels();
      this.navigate(url);
      return;
    }

    const bucket = event.target.closest('[data-price-bucket]');
    if (bucket) {
      event.preventDefault();
      this.closeAllPanels();
      this.navigatePriceBucket(bucket);
      return;
    }

    const sortOption = event.target.closest('[data-sort-option]');
    if (sortOption) {
      event.preventDefault();
      this.closeAllPanels();
      const url = new URL(this.form.getAttribute('action'), window.location.origin);
      const params = new URLSearchParams(window.location.search);
      params.set('sort_by', sortOption.dataset.value);
      url.search = params.toString();
      this.navigate(url.pathname + url.search);
      return;
    }

    const resetBtn = event.target.closest('[data-facet-reset]');
    if (resetBtn) {
      event.preventDefault();
      if (resetBtn.disabled) return;
      this.navigate(this.form.getAttribute('action'));
    }
  }

  navigatePriceBucket(bucket) {
    const isActive = bucket.getAttribute('aria-pressed') === 'true';
    const params = new URLSearchParams(window.location.search);
    const minParam = bucket.dataset.minParam;
    const maxParam = bucket.dataset.maxParam;

    if (isActive) {
      params.delete(minParam);
      params.delete(maxParam);
    } else {
      if (bucket.dataset.min) {
        params.set(minParam, bucket.dataset.min);
      } else {
        params.delete(minParam);
      }
      if (bucket.dataset.max) {
        params.set(maxParam, bucket.dataset.max);
      } else {
        params.delete(maxParam);
      }
    }

    const base = this.form.getAttribute('action').split('?')[0];
    const query = params.toString();
    this.navigate(query ? `${base}?${query}` : base);
  }

  async navigate(url) {
    if (!url) return;
    this.setAttribute('data-loading', '');

    const resultsList = document.getElementById('ResultsList') || document.querySelector('[data-results-list]');

    try {
      const target = new URL(url, window.location.origin);
      target.searchParams.set('section_id', this.getAttribute('section-id'));

      const response = await fetch(target.toString());
      if (!response.ok) throw new Error(`Request failed: ${response.status}`);
      const text = await response.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');

      const newBar = doc.querySelector('facets-filter-bar');
      if (newBar) this.replaceWith(newBar);

      const newResults = doc.getElementById('ResultsList') || doc.querySelector('[data-results-list]');
      if (newResults && resultsList) resultsList.innerHTML = newResults.innerHTML;

      const cleanUrl = new URL(url, window.location.origin);
      history.pushState({}, '', cleanUrl.pathname + cleanUrl.search);
      window.dispatchEvent(new CustomEvent('facets:updated'));
    } catch (error) {
      window.location.href = url;
    } finally {
      this.removeAttribute('data-loading');
    }
  }
}

if (!customElements.get('facets-filter-bar')) {
  customElements.define('facets-filter-bar', FacetsFilterBar);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    class ZehnFacets extends HTMLElement {
  constructor() {
    super();
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
  }

  connectedCallback() {
    this.form = this.querySelector('[data-facets-form]');
    this.addEventListener('click', this.onClick);
    this.addEventListener('keydown', this.onKeydown);
    document.addEventListener('click', this.onDocumentClick);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocumentClick);
  }

  onDocumentClick(event) {
    if (!this.isConnected) return;
    if (!this.contains(event.target)) this.closeAll();
  }

  onKeydown(event) {
    if (event.key === 'Escape') this.closeAll();
  }

  closeAll() {
    this.querySelectorAll('[data-facet-panel], [data-sort-panel]').forEach((panel) => {
      panel.hidden = true;
    });
    this.querySelectorAll('[data-facet-trigger], [data-sort-trigger]').forEach((trigger) => {
      trigger.setAttribute('aria-expanded', 'false');
    });
  }

  toggle(trigger) {
    const panel = trigger.parentElement.querySelector('[data-facet-panel], [data-sort-panel]');
    const wasOpen = trigger.getAttribute('aria-expanded') === 'true';
    this.closeAll();
    if (!wasOpen && panel) {
      panel.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
    }
  }

  onClick(event) {
    const trigger = event.target.closest('[data-facet-trigger], [data-sort-trigger]');
    if (trigger) {
      event.preventDefault();
      this.toggle(trigger);
      return;
    }

    /* Multi-select: the panel deliberately stays open so several values can be
       ticked in a row. The open panel + its scroll position are restored after
       the refreshed markup swaps in. */
    const option = event.target.closest('[data-facet-option]');
    if (option) {
      event.preventDefault();
      if (option.disabled) return;
      const isActive = option.getAttribute('aria-pressed') === 'true';
      const url = isActive ? option.dataset.urlRemove : option.dataset.urlAdd;
      this.markOption(option, !isActive);
      this.navigate(url, this.captureOpenState());
      return;
    }

    const bucket = event.target.closest('[data-price-bucket]');
    if (bucket) {
      event.preventDefault();
      this.navigatePriceBucket(bucket, this.captureOpenState());
      return;
    }

    const sortOption = event.target.closest('[data-sort-option]');
    if (sortOption) {
      event.preventDefault();
      this.closeAll();
      const params = new URLSearchParams(window.location.search);
      params.set('sort_by', sortOption.dataset.value);
      const base = this.form.getAttribute('action').split('?')[0];
      this.navigate(`${base}?${params.toString()}`);
      return;
    }

    const reset = event.target.closest('[data-facet-reset]');
    if (reset) {
      event.preventDefault();
      if (reset.disabled) return;
      this.navigate(this.form.getAttribute('action').split('?')[0]);
    }
  }

  /* Which panel is open, and how far its list is scrolled. */
  captureOpenState() {
    const items = Array.from(this.querySelectorAll('[data-facet-item]'));
    const index = items.findIndex((item) => {
      const trigger = item.querySelector('[data-facet-trigger]');
      return trigger && trigger.getAttribute('aria-expanded') === 'true';
    });
    if (index === -1) return null;
    const list = items[index].querySelector('.zf__list');
    return { index: index, scrollTop: list ? list.scrollTop : 0 };
  }

  restoreOpenState(state) {
    if (!state) return;
    const item = this.querySelectorAll('[data-facet-item]')[state.index];
    if (!item) return;
    const trigger = item.querySelector('[data-facet-trigger]');
    const panel = item.querySelector('[data-facet-panel]');
    if (!trigger || !panel) return;
    panel.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    const list = panel.querySelector('.zf__list');
    if (list) list.scrollTop = state.scrollTop;
  }

  /* Optimistic tick so the row responds instantly, before the refresh lands. */
  markOption(option, active) {
    option.setAttribute('aria-pressed', String(active));
    option.classList.toggle('is-active', active);
    const existing = option.querySelector('.zf__check');
    if (active && !existing) {
      option.insertAdjacentHTML('beforeend', ZehnFacets.CHECK_ICON);
    } else if (!active && existing) {
      existing.remove();
    }
  }

  /* Shopify's price filter is a single gte/lte pair, so "multi-select" means the
     selected buckets form one contiguous span. Clicking an unselected bucket
     widens the span to reach it; clicking a selected one trims the span back. */
  navigatePriceBucket(bucket, openState) {
    const panel = bucket.closest('[data-facet-panel]');
    const buckets = panel ? Array.from(panel.querySelectorAll('[data-price-bucket]')) : [bucket];
    const clicked = buckets.indexOf(bucket);
    const active = buckets.map((b) => b.getAttribute('aria-pressed') === 'true');
    const first = active.indexOf(true);
    const last = active.lastIndexOf(true);

    let from = clicked;
    let to = clicked;

    if (first === -1) {
      /* nothing selected yet */
    } else if (!active[clicked]) {
      from = Math.min(first, clicked);
      to = Math.max(last, clicked);
    } else if (first === last) {
      from = -1; /* the only selected bucket — clear the filter */
    } else if (clicked === first) {
      from = clicked + 1;
      to = last;
    } else {
      /* the top of the span, or somewhere in the middle: keep the lower part */
      from = first;
      to = clicked - 1;
    }

    const params = new URLSearchParams(window.location.search);
    const minParam = bucket.dataset.minParam;
    const maxParam = bucket.dataset.maxParam;

    params.delete(minParam);
    params.delete(maxParam);

    if (from !== -1) {
      const min = buckets[from].dataset.min;
      const max = buckets[to].dataset.max;
      if (min) params.set(minParam, min);
      if (max) params.set(maxParam, max);
    }

    /* Instant feedback for the whole span, before the refresh lands. */
    buckets.forEach((b, i) => {
      this.markOption(b, from !== -1 && i >= from && i <= to);
    });

    const base = this.form.getAttribute('action').split('?')[0];
    const query = params.toString();
    this.navigate(query ? `${base}?${query}` : base, openState);
  }

  async navigate(url, openState) {
    if (!url) return;
    this.setAttribute('data-loading', '');

    /* Prefer the wrapper that holds *either* the grid or the empty state, so a
       filter combination with no matches can swap the message in. Falls back to
       the bare results list when the wrapper isn't present. */
    const resultsList =
      document.querySelector('[data-collection-results]') ||
      document.getElementById('ResultsList') ||
      document.querySelector('[data-results-list]');

    try {
      const target = new URL(url, window.location.origin);
      target.searchParams.set('section_id', this.getAttribute('section-id'));

      const response = await fetch(target.toString());
      if (!response.ok) throw new Error(`Request failed: ${response.status}`);

      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');

      const newResults =
        doc.querySelector('[data-collection-results]') ||
        doc.getElementById('ResultsList') ||
        doc.querySelector('[data-results-list]');
      if (newResults && resultsList) resultsList.innerHTML = newResults.innerHTML;

      const clean = new URL(url, window.location.origin);
      history.pushState({}, '', clean.pathname + clean.search);
      window.dispatchEvent(new CustomEvent('facets:updated'));

      const newBar = doc.querySelector('zehn-facets');
      if (newBar) {
        this.replaceWith(newBar);
        /* replaceWith adopts + upgrades the element synchronously, so the
           custom-element methods are available immediately. */
        if (typeof newBar.restoreOpenState === 'function') {
          newBar.restoreOpenState(openState);
        }
      }
    } catch (error) {
      window.location.href = url;
    } finally {
      this.removeAttribute('data-loading');
    }
  }
}

ZehnFacets.CHECK_ICON =
  '<svg class="zf__check" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"></path></svg>';

if (!customElements.get('zehn-facets')) {
  customElements.define('zehn-facets', ZehnFacets);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-details-popup"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__pdpDetailsPopupInit) return;
  window.__pdpDetailsPopupInit = true;

  var GAP = 16;
  var instances = Object.create(null);

  function qs(el, sel) { return el.querySelector(sel); }
  function qsa(el, sel) { return Array.prototype.slice.call(el.querySelectorAll(sel)); }

  function build(uid) {
    var tpl = document.querySelector('[data-pdp-template="' + uid + '"]');
    var cfgEl = document.querySelector('[data-pdp-config="' + uid + '"]');
    var root = document.getElementById(uid + '-root');
    if (!tpl || !cfgEl) return null;

    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return null; }

    var modal = tpl.content.firstElementChild.cloneNode(true);
    if (root && root.getAttribute('style')) {
      modal.setAttribute('style', root.getAttribute('style'));
    }
    document.body.appendChild(modal);

    var inst = {
      uid: uid,
      cfg: cfg,
      modal: modal,
      form: qs(modal, '[data-pdp-form]'),
      idInput: qs(modal, '[data-pdp-variant-id]'),
      priceEl: qs(modal, '[data-pdp-price]'),
      compareEl: qs(modal, '[data-pdp-compare]'),
      addBtn: qs(modal, '[data-pdp-add]'),
      addText: qs(modal, '[data-pdp-add-text]'),
      buyBtn: qs(modal, '[data-pdp-buy]'),
      track: qs(modal, '[data-pdp-track]'),
      prev: qs(modal, '[data-pdp-prev]'),
      next: qs(modal, '[data-pdp-next]'),
      slides: qsa(modal, '[data-pdp-slide]'),
      fields: qsa(modal, '[data-pdp-option]'),
      statusEl: qs(modal, '[data-pdp-status]'),
      lastFocus: null,
      lastSubmitter: null,
      addedTimer: null,
      ready: false,
      state: [],
      stateH: []
    };

    /* ---- initial selection ---- */
    inst.fields.forEach(function (fs) {
      var i = parseInt(fs.getAttribute('data-pdp-option'), 10);
      var checked = qs(fs, 'input:checked');
      var label = checked ? checked.closest('[data-pdp-opt]') : qs(fs, '[data-pdp-opt]');
      inst.state[i] = label ? label.getAttribute('data-pdp-value') : '';
      inst.stateH[i] = label ? label.getAttribute('data-pdp-value-handle') : '';
    });

    /* ---- option clicks ---- */
    inst.fields.forEach(function (fs) {
      var i = parseInt(fs.getAttribute('data-pdp-option'), 10);
      fs.addEventListener('change', function (e) {
        var label = e.target.closest('[data-pdp-opt]');
        if (!label) return;
        inst.state[i] = label.getAttribute('data-pdp-value');
        inst.stateH[i] = label.getAttribute('data-pdp-value-handle');
        update(inst, i === inst.cfg.colorIndex);
      });
    });

    /* ---- add to cart ---- */
    if (inst.form) {
      /* e.submitter is not universally reported, so remember the last button pressed */
      inst.form.addEventListener('click', function (e) {
        var b = e.target.closest('button[type="submit"]');
        if (b) inst.lastSubmitter = b;
      }, true);

      inst.form.addEventListener('submit', function (e) {
        if (!inst.cfg.ajax) return;
        var who = e.submitter || inst.lastSubmitter;
        /* Buy now must stay a real navigation to /checkout */
        if (who && who === inst.buyBtn) return;
        e.preventDefault();
        addToCart(inst);
      });
    }

    /* ---- gallery nav ---- */
    if (inst.track) {
      var step = function () {
        var vis = inst.slides.filter(function (s) { return !s.hidden; });
        return vis.length ? vis[0].getBoundingClientRect().width + GAP : inst.track.clientWidth;
      };
      if (inst.prev) inst.prev.addEventListener('click', function () {
        inst.track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      if (inst.next) inst.next.addEventListener('click', function () {
        inst.track.scrollBy({ left: step(), behavior: 'smooth' });
      });
      inst.track.addEventListener('scroll', function () { updateNav(inst); }, { passive: true });
    }

    /* ---- keyboard ---- */
    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); close(uid); return; }
      if (e.key !== 'Tab') return;
      var f = qsa(modal, 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]')
        .filter(function (el) {
          if (el.getAttribute('tabindex') === '-1') return false;
          return el.offsetParent !== null || el === document.activeElement;
        });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    instances[uid] = inst;
    update(inst, true);
    return inst;
  }

  function findVariant(inst, state) {
    var vs = inst.cfg.variants;
    for (var i = 0; i < vs.length; i++) {
      var ok = true;
      for (var j = 0; j < state.length; j++) {
        if (vs[i].options[j] !== state[j]) { ok = false; break; }
      }
      if (ok) return vs[i];
    }
    return null;
  }

  /* Is any purchasable variant available with `value` at `optIndex`,
     holding every other currently selected option fixed? */
  function valueAvailable(inst, optIndex, value) {
    var vs = inst.cfg.variants;
    for (var i = 0; i < vs.length; i++) {
      if (vs[i].options[optIndex] !== value) continue;
      var ok = true;
      for (var j = 0; j < inst.state.length; j++) {
        if (j === optIndex) continue;
        if (vs[i].options[j] !== inst.state[j]) { ok = false; break; }
      }
      if (ok && vs[i].available) return true;
    }
    return false;
  }

  function update(inst, colorChanged) {
    var cfg = inst.cfg;

    inst.fields.forEach(function (fs) {
      var i = parseInt(fs.getAttribute('data-pdp-option'), 10);
      var out = qs(fs, '[data-pdp-selected-value]');
      if (out) out.innerHTML = '&mdash; ' + inst.state[i];
      qsa(fs, '[data-pdp-opt]').forEach(function (label) {
        var val = label.getAttribute('data-pdp-value');
        var selected = val === inst.state[i];
        label.classList.toggle('is-selected', selected);
        label.classList.toggle('is-unavailable', !valueAvailable(inst, i, val));
        var input = qs(label, 'input');
        if (input) input.checked = selected;
      });
    });

    var v = findVariant(inst, inst.state);

    if (inst.priceEl && v) inst.priceEl.innerHTML = v.price;
    if (inst.compareEl) {
      if (v && v.compareAt) { inst.compareEl.innerHTML = v.compareAt; inst.compareEl.hidden = false; }
      else { inst.compareEl.hidden = true; }
    }

    if (inst.idInput) inst.idInput.value = v ? v.id : '';

    var buyable = !!(v && v.available);
    if (inst.addBtn) inst.addBtn.disabled = !buyable;
    if (inst.buyBtn) inst.buyBtn.disabled = !buyable;
    if (inst.addText) {
      inst.addText.textContent = !v ? cfg.unavailableText
        : (v.available ? cfg.addToCartText : cfg.soldOutText);
    }

    resetAdd(inst);
    hideStatus(inst);

    if (colorChanged) {
      filterGallery(inst);
      if (inst.cfg.scrollToVariantMedia) scrollToMedia(inst, v, inst.ready);
    }
    updateNav(inst);
    inst.ready = true;
  }

  /* Bring the selected colour's own photo into view. Falls back to the first
     visible slide when the variant has no featured image of its own. */
  function scrollToMedia(inst, v, smooth) {
    if (!inst.track) return;
    var target = null, i;

    if (v && v.mediaId != null) {
      for (i = 0; i < inst.slides.length; i++) {
        if (!inst.slides[i].hidden &&
            inst.slides[i].getAttribute('data-pdp-media-id') === String(v.mediaId)) {
          target = inst.slides[i];
          break;
        }
      }
    }
    if (!target) {
      for (i = 0; i < inst.slides.length; i++) {
        if (!inst.slides[i].hidden) { target = inst.slides[i]; break; }
      }
    }
    if (!target) return;

    /* offsetLeft is the unscrolled layout position, so it stays correct no
       matter where the track is currently scrolled or how wide it measures. */
    var left;
    if (target.offsetParent && target.offsetParent === inst.track.offsetParent) {
      left = target.offsetLeft - inst.track.offsetLeft;
    } else {
      left = inst.track.scrollLeft +
        (target.getBoundingClientRect().left - inst.track.getBoundingClientRect().left);
    }
    if (left < 0) left = 0;

    if (smooth && typeof inst.track.scrollTo === 'function') {
      inst.track.scrollTo({ left: left, behavior: 'smooth' });
    } else {
      /* the track sets scroll-behavior: smooth, which would animate even a
         direct assignment — opening should snap, not glide */
      var prev = inst.track.style.scrollBehavior;
      inst.track.style.scrollBehavior = 'auto';
      inst.track.scrollLeft = left;
      inst.track.style.scrollBehavior = prev;
    }
  }

  /* ---------- add to cart ---------- */

  function showStatus(inst, msg) {
    if (!inst.statusEl) return;
    inst.statusEl.textContent = msg;
    inst.statusEl.hidden = false;
  }

  function hideStatus(inst) {
    if (inst.statusEl) inst.statusEl.hidden = true;
  }

  function resetAdd(inst) {
    if (inst.addedTimer) { clearTimeout(inst.addedTimer); inst.addedTimer = null; }
    if (!inst.addBtn) return;
    inst.addBtn.classList.remove('is-added', 'is-loading');

    var v = findVariant(inst, inst.state);
    var buyable = !!(v && v.available);
    inst.addBtn.disabled = !buyable;
    if (inst.buyBtn) inst.buyBtn.disabled = !buyable;
    if (inst.addText) {
      inst.addText.textContent = !v ? inst.cfg.unavailableText
        : (v.available ? inst.cfg.addToCartText : inst.cfg.soldOutText);
    }
  }

  function markAdded(inst) {
    if (!inst.addBtn) return;
    inst.addBtn.classList.remove('is-loading');
    inst.addBtn.classList.add('is-added');
    inst.addBtn.disabled = true;
    if (inst.addText) inst.addText.textContent = inst.cfg.addedText;

    /* Buy now is a separate action — don't hold it hostage for the whole window */
    if (inst.buyBtn) {
      var bv = findVariant(inst, inst.state);
      inst.buyBtn.disabled = !(bv && bv.available);
    }

    if (inst.addedTimer) clearTimeout(inst.addedTimer);
    inst.addedTimer = setTimeout(function () {
      inst.addedTimer = null;
      resetAdd(inst);
    }, inst.cfg.addedMs);
  }

  /* Refresh whatever cart UI the theme has. Returns a promise. */
  function refreshCart() {
    var d = window.ZehnCartDrawer;
    var done;

    if (d && typeof d.refresh === 'function') {
      done = Promise.resolve(d.refresh());
    } else {
      document.dispatchEvent(new CustomEvent('zehn:cart:refresh', { bubbles: true }));
      done = Promise.resolve();
    }

    /* generic events other themes / apps listen for */
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
    return done;
  }

  function openDrawer() {
    var d = window.ZehnCartDrawer;
    if (d && typeof d.open === 'function') d.open();
    else document.dispatchEvent(new CustomEvent('zehn:cart:open', { bubbles: true }));
  }

  function addToCart(inst) {
    if (!inst.addBtn || inst.addBtn.classList.contains('is-loading')) return;
    var id = inst.idInput ? inst.idInput.value : '';
    if (!id) return;

    hideStatus(inst);
    inst.addBtn.classList.add('is-loading');
    inst.addBtn.disabled = true;
    if (inst.buyBtn) inst.buyBtn.disabled = true;

    fetch(inst.cfg.addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      })
      .then(function (r) {
        if (!r.ok) throw new Error((r.data && (r.data.description || r.data.message)) || '');
        markAdded(inst);
        return refreshCart().then(function () {
          if (inst.cfg.afterAdd === 'drawer') {
            close(inst.uid);
            openDrawer();
          }
        });
      })
      .catch(function (err) {
        inst.addBtn.classList.remove('is-loading');
        var v = findVariant(inst, inst.state);
        inst.addBtn.disabled = !(v && v.available);
        if (inst.buyBtn) inst.buyBtn.disabled = !(v && v.available);
        showStatus(inst, (err && err.message) || inst.cfg.errorText);
      });
  }

  function filterGallery(inst) {
    var cfg = inst.cfg;
    if (!inst.track || cfg.colorIndex < 0) return;
    var probe = '|' + inst.stateH[cfg.colorIndex] + '|';
    var shown = 0;

    inst.slides.forEach(function (s) {
      var tags = s.getAttribute('data-pdp-colors') || '';
      var show = tags ? tags.indexOf(probe) !== -1 : !!cfg.unassignedMedia;
      s.hidden = !show;
      if (show) shown++;
    });

    /* never leave the gallery empty */
    if (!shown) inst.slides.forEach(function (s) { s.hidden = false; });
  }

  function updateNav(inst) {
    if (!inst.track || !inst.prev || !inst.next) return;
    var max = inst.track.scrollWidth - inst.track.clientWidth;
    inst.prev.disabled = inst.track.scrollLeft <= 4;
    inst.next.disabled = max <= 4 || inst.track.scrollLeft >= max - 4;
  }

  function open(uid) {
    var inst = instances[uid] || build(uid);
    if (!inst) return;
    inst.lastFocus = document.activeElement;
    inst.modal.hidden = false;
    document.documentElement.classList.add('pdp-scroll-lock');
    document.body.classList.add('pdp-scroll-lock');
    /* The gallery can only be measured once the panel is actually laid out,
       so position it here rather than at build time. */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (inst.cfg.scrollToVariantMedia) {
          scrollToMedia(inst, findVariant(inst, inst.state), false);
        }
        updateNav(inst);
      });
      var c = qs(inst.modal, '.pdp-close');
      if (c) c.focus();
    });
  }

  function close(uid) {
    var inst = instances[uid];
    if (!inst) return;
    resetAdd(inst);
    hideStatus(inst);
    inst.modal.hidden = true;
    document.documentElement.classList.remove('pdp-scroll-lock');
    document.body.classList.remove('pdp-scroll-lock');
    if (inst.lastFocus && inst.lastFocus.focus) inst.lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var opener = e.target.closest('[data-pdp-open]');
    if (opener) { e.preventDefault(); open(opener.getAttribute('data-pdp-open')); return; }

    var closer = e.target.closest('[data-pdp-close]');
    if (closer) {
      var m = closer.closest('.pdp-modal');
      if (m) { e.preventDefault(); close(m.getAttribute('data-pdp-modal')); }
    }
  });

  /* Theme editor: blocks re-render, so drop stale clones and rebuild on demand. */
  document.addEventListener('shopify:section:load', function () {
    Object.keys(instances).forEach(function (uid) {
      var inst = instances[uid];
      if (inst.modal && inst.modal.parentNode) inst.modal.parentNode.removeChild(inst.modal);
      delete instances[uid];
    });
    document.documentElement.classList.remove('pdp-scroll-lock');
    document.body.classList.remove('pdp-scroll-lock');
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["size-chart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('size-chart-group')) {
    class SizeChartGroup extends HTMLElement {
      connectedCallback() {
        this.onClick = this.onClick.bind(this);
        this.addEventListener('click', this.onClick);

        // Each table keeps its own unit, so seed them from the markup.
        this.querySelectorAll('.sgc-chart').forEach((chart) => {
          const active = chart.querySelector('[data-sgc-unit].is-active');
          this.setUnit(chart, active ? active.dataset.sgcUnit : 'cm');
        });
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      onClick(event) {
        const button = event.target.closest('[data-sgc-unit]');
        if (!button || !this.contains(button)) return;
        event.preventDefault();
        const chart = button.closest('.sgc-chart');
        if (chart) this.setUnit(chart, button.dataset.sgcUnit);
      }

      setUnit(chart, unit) {
        const isInch = unit === 'inch';
        let separator = this.dataset.decimalSeparator || ',';
        // Older saved settings stored the words rather than the characters.
        if (separator === 'comma') separator = ',';
        if (separator === 'point' || separator === 'dot') separator = '.';
        const suffix = isInch
          ? this.dataset.inchSuffix || 'inch'
          : this.dataset.cmSuffix || 'cm';
        const factor = parseFloat(this.dataset.factor) || 2.54;
        const decimals = parseInt(this.dataset.decimals, 10);
        const places = isNaN(decimals) ? 2 : decimals;

        chart.querySelectorAll('[data-sgc-unit]').forEach((btn) => {
          const active = btn.dataset.sgcUnit === unit;
          btn.classList.toggle('is-active', active);
          btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        chart.querySelectorAll('[data-sgc-unit-label]').forEach((el) => {
          el.textContent = '(' + suffix + ')';
        });

        chart.querySelectorAll('[data-sgc-cm]').forEach((cell) => {
          const raw = (cell.dataset.sgcCm || '').trim();
          if (!isInch) {
            cell.textContent = raw;
            return;
          }
          // "bis 174" and "175–186" are not numbers — leave them as typed.
          const numeric = parseFloat(raw.replace(',', '.'));
          if (isNaN(numeric) || !/^[\d.,\s]+$/.test(raw)) {
            cell.textContent = raw;
            return;
          }
          let converted = (numeric / factor).toFixed(places);
          if (converted.indexOf('.') !== -1) {
            converted = converted.replace(/0+$/, '').replace(/\.$/, '');
          }
          cell.textContent = converted.replace('.', separator);
        });
      }
    }

    customElements.define('size-chart-group', SizeChartGroup);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sizeguidebadges"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('size-guide-badges')) {
  class SizeGuideBadges extends HTMLElement {
    connectedCallback() {
      this.lastFocused = null;

      // Portal every modal out to <body>. This is the actual fix: whatever ancestor
      // (section wrapper, animation wrapper, etc.) sits between this element and <body>
      // can no longer trap the modal inside a lower stacking context, regardless of
      // what z-index or transform that ancestor uses.
      this.modals = Array.from(this.querySelectorAll('[data-sg-modal]'));
      this.modals.forEach((modal) => document.body.appendChild(modal));

      this.onOpenerClick = this.onOpenerClick.bind(this);
      this.onModalClick = this.onModalClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);

      this.addEventListener('click', this.onOpenerClick);
      this.modals.forEach((modal) => modal.addEventListener('click', this.onModalClick));
      document.addEventListener('keydown', this.onKeydown);

      const initial = this.findInModals('[data-sg-unit].is-active');
      this.setUnit(initial ? initial.dataset.sgUnit : 'cm');
    }
    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
      document.body.classList.remove('sg-body-locked');
      // Remove the portaled modals so a theme-editor re-render doesn't leave orphans in <body>.
      this.modals.forEach((modal) => modal.remove());
    }
    findInModals(selector) {
      for (const modal of this.modals) {
        const found = modal.querySelector(selector);
        if (found) return found;
      }
      return null;
    }
    onOpenerClick(event) {
      const opener = event.target.closest('[data-sg-open]');
      if (!opener || !this.contains(opener)) return;
      event.preventDefault();
      this.open(opener.dataset.sgOpen, opener);
    }
    onModalClick(event) {
      const closer = event.target.closest('[data-sg-close]');
      if (closer) { event.preventDefault(); this.close(); return; }
      const unitBtn = event.target.closest('[data-sg-unit]');
      if (unitBtn) { event.preventDefault(); this.setUnit(unitBtn.dataset.sgUnit); }
    }
    onKeydown(event) {
      if (event.key !== 'Escape' && event.key !== 'Esc') return;
      if (this.modals.some((modal) => !modal.hidden)) this.close();
    }
    open(name, trigger) {
      const modal = this.modals.find((m) => m.dataset.sgModal === name);
      if (!modal) return;
      this.close();
      this.lastFocused = trigger || document.activeElement;
      modal.hidden = false;
      document.body.classList.add('sg-body-locked');
      const focusTarget = modal.querySelector('.sg-modal__close') || modal;
      window.requestAnimationFrame(() => focusTarget.focus({ preventScroll: true }));
    }
    close() {
      const open = this.modals.filter((modal) => !modal.hidden);
      if (!open.length) return;
      open.forEach((modal) => { modal.hidden = true; });
      document.body.classList.remove('sg-body-locked');
      if (this.lastFocused && typeof this.lastFocused.focus === 'function') this.lastFocused.focus({ preventScroll: true });
      this.lastFocused = null;
    }
    setUnit(unit) {
      const isInch = unit === 'inch';
      const separator = this.dataset.decimalSeparator || ',';
      const suffix = isInch ? (this.dataset.inchSuffix || 'inch') : (this.dataset.cmSuffix || 'cm');
      this.modals.forEach((modal) => {
        modal.querySelectorAll('[data-sg-unit]').forEach((btn) => {
          const active = btn.dataset.sgUnit === unit;
          btn.classList.toggle('is-active', active);
          btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        modal.querySelectorAll('[data-sg-unit-label]').forEach((el) => { el.textContent = '(' + suffix + ')'; });
        modal.querySelectorAll('[data-sg-cm]').forEach((cell) => {
          const raw = (cell.dataset.sgCm || '').trim();
          if (!isInch) { cell.textContent = raw; return; }
          const numeric = parseFloat(raw.replace(',', '.'));
          if (isNaN(numeric)) { cell.textContent = raw; return; }
          let converted = (numeric / 2.54).toFixed(2);
          converted = converted.replace(/0+$/, '').replace(/\.$/, '');
          cell.textContent = converted.replace('.', separator);
        });
      });
    }
  }
  customElements.define('size-guide-badges', SizeGuideBadges);
}
  } catch(e) { console.error(e); }
})();

})();
